import React, { useEffect, useState } from 'react';
import {
  Icon,
  Title,
  faArrowRight,
  faMagnifyingGlass,
  faPassport,
  PageContainer,
} from '@/ui/components';
import { useTranslate } from '@/translations';
import { useAppCustomers } from '@/hooks';
import { useTheme } from 'styled-components';
import { useSearchParams } from 'react-router-dom';

import { Empty, Input } from 'antd';
import { PassportBook } from './components/PassportBook';
import { TravelRecord } from './components/TravelRecord';

const { Search } = Input;

export const Passport = () => {
  const { t } = useTranslate();
  const { passport } = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchValue = (searchParams.get('search') || '').trim();
  const { hasGbaAccess } = useAppCustomers();
  const design = hasGbaAccess ? '2' : '1';
  const setSearchValue = (value: string) =>
    setSearchParams((params) => {
      if (value.trim()) params.set('search', value.trim());
      else params.delete('search');
      return params;
    });
  const [vinInput, setVinInput] = useState(searchValue);
  useEffect(() => setVinInput(searchValue), [searchValue]);

  const searchBox = (
    <Search
      size="large"
      placeholder="Enter vehicle VIN"
      aria-label="Vehicle VIN"
      value={vinInput}
      onChange={(e) => setVinInput(e.target.value)}
      onSearch={(value) => setSearchValue(value.toUpperCase())}
      onClear={() => setSearchValue('')}
      prefix={<Icon icon={faMagnifyingGlass} color="#8a94a6" />}
      enterButton={
        <>
          Search <Icon icon={faArrowRight} />
        </>
      }
      maxLength={17}
      styles={{
        input: { textTransform: 'uppercase', letterSpacing: '0.06em' },
      }}
      style={{ width: 460, maxWidth: '100%', alignSelf: 'center' }}
      allowClear
    />
  );

  return (
    <PageContainer style={{ minHeight: '100%' }}>
      <div
        className="align-items-center"
        style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr' }}
      >
        <Title title={t('passport')} icon={faPassport} color={passport} />
        {searchValue ? searchBox : <span />}
      </div>

      <div className="d-flex flex-column flex-grow-1">
        <div style={{ flexGrow: 1 }} />
        <div className="d-flex flex-column" style={{ gap: 24 }}>
          {!searchValue ? (
            <>
              {searchBox}
              <Empty description="Search a VIN to open its passport" />
            </>
          ) : design === '2' ? (
            <TravelRecord key={searchValue} vin={searchValue} />
          ) : (
            <PassportBook key={searchValue} vin={searchValue} />
          )}
        </div>
        <div style={{ flexGrow: 2 }} />
      </div>
    </PageContainer>
  );
};
